const getters = {
  unreadCount: state => state.unreadCount,
  hasUnreadNotifications: state => state.unreadCount > 0
}

export default getters
